import React from 'react';
import cn from 'clsx';

import Button from '../../library/button/button';

import { useModal, useMyAccount } from '../../shared/hooks/hooks';

import { getSignInPromo } from '../../shared/utils/cart/cart';

import { PromotionData } from '../../shared/types/graphql-types';
import { SIGN_IN_MODAL } from '../../shared/constants/modals';

import styles from './sign-in-to-save.scss';

//TODO: added link for pillar promo content in PLP, will be used in PS-4038
export enum SignInToSaveVariant {
  BUTTON = 'BUTTON',
  LINK = 'LINK'
}

interface SignInToSaveProps {
  badgeIcon?: string;
  className?: string;
  primaryColor?: string;
  promos: Array<PromotionData | null> | undefined | null;
  secondaryColor?: string;
  variant?: SignInToSaveVariant;
}

function SignInToSave(props: SignInToSaveProps) {
  const {
    badgeIcon,
    className,
    primaryColor,
    promos,
    secondaryColor,
    variant = SignInToSaveVariant.BUTTON
  } = props;
  const { isLoggedIn } = useMyAccount();
  const { openModal } = useModal();

  const signInPromo = getSignInPromo(promos);

  if (!signInPromo || (!signInPromo.shortDescription && !signInPromo.title)) {
    return null;
  }

  const messageHtml = isLoggedIn
    ? signInPromo.title
    : signInPromo.shortDescription;

  const handleSignIn = () => {
    openModal(SIGN_IN_MODAL, {
      shouldUseHashRouter: false
    });
  };

  return (
    <div
      className={cn(styles['container'], className, {
        [styles['container--link']]: variant === SignInToSaveVariant.LINK
      })}
    >
      {badgeIcon && (
        <div
          className={cn(styles['sticker'], {
            [styles['sticker--link']]: variant === SignInToSaveVariant.LINK
          })}
        >
          <img alt="" className={styles['sticker-image']} src={badgeIcon} />
        </div>
      )}
      {variant === SignInToSaveVariant.BUTTON && (
        <div
          className={cn(styles['message'], {
            [styles['message--with-sticker']]: Boolean(badgeIcon)
          })}
          dangerouslySetInnerHTML={{ __html: messageHtml || '' }}
        />
      )}
      {!isLoggedIn && variant === SignInToSaveVariant.BUTTON && (
        <>
          <div className={styles['button-container']}>
            <Button
              className={styles['sign-in-button']}
              isSecondary
              onClick={handleSignIn}
            >
              SIGN IN TO SAVE
            </Button>
          </div>
          <div
            className={styles['primary-line']}
            style={primaryColor ? { background: primaryColor } : undefined}
          />
          <div
            className={styles['secondary-line']}
            style={secondaryColor ? { background: secondaryColor } : undefined}
          />
        </>
      )}
      {!isLoggedIn && variant === SignInToSaveVariant.LINK && (
        <button
          className={cn(styles['message'], styles['message--link'])}
          dangerouslySetInnerHTML={{
            __html: signInPromo.shortDescription || ''
          }}
          onClick={handleSignIn}
          style={primaryColor ? { background: primaryColor } : undefined}
          type="button"
        />
      )}
      {isLoggedIn && variant === SignInToSaveVariant.LINK && (
        <div
          className={cn(styles['message'], styles['message--link'])}
          dangerouslySetInnerHTML={{
            __html: signInPromo.title || ''
          }}
          style={primaryColor ? { background: primaryColor } : undefined}
        />
      )}
    </div>
  );
}

export default SignInToSave;
